import { StatusCommande } from '@/enum/StatusCommande';
import Vue from 'vue'

export const statusCmd = (value: number) => {    
    switch(value){
        case StatusCommande.bcd: return "Bon de commande";
        case StatusCommande.paye: return "Payé";
        case StatusCommande.preparation: return "En préparation";
        case StatusCommande.envoye: return "Envoyé";
        case StatusCommande.livre: return "Livré";
        case StatusCommande.annule: return "Annulé";
        case StatusCommande.rembourse: return "Remboursé";
        case StatusCommande.enLivraison: return "En livraison";
        case StatusCommande.enAttentePaiement: return "En attente de paiement";
        case StatusCommande.devis: return "Devis";
        case StatusCommande.enCoursAppro: return "En cours d'approvisionnement";
        case StatusCommande.erreur: return "Erreur";
    } 
    return "";    
}
Vue.filter('statusCmd', statusCmd)